import GetIntegrationCallStepsByCallIdRequestModelBase from '../_generated/modelBases/get-integration-call-steps-by-call-id-request-model-base';

export default class GetIntegrationCallStepsByCallIdRequestModel extends GetIntegrationCallStepsByCallIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
